import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Col, Container, Row } from "react-bootstrap";

function Testimonial() {
  const testimonialLists = [
    {
      content:
        "Great work, fast, quality, and fun to talk too. great communication! let Centillion know what to do and they will do it.",
      skills: "JavaScript, CSS, AngularJS, React.js, Vue.js",
      name: "Matthew B",
      location: "USA",
    },
    {
      content:
        "Centillion is very professional, trustworthy Delivered on time. Will hire them again.",
      skills: "Website Design, Node.js, React.js, Framework",
      name: "Nithin A",
      location: "India",
    },
    {
      content:
        "Centillion helped me complete my task on time and within budget. I highly recommend them",
      skills: " Programming, AngularJS, LINQ, ASP.NET, MVC",
      name: "Harsha D.",
      location: "USA",
    },
    {
      content:
        "Centillion is fantastic. Great communicator.  We highly respect what Centillion brings to the table and would recommend them to others.",
      skills: "JavaScript, CSS, HTML5,  AngularJS",
      name: "Donald M.",
      location: "USA",
    },
    {
      content:
        "A great team that delivered excellent work. I look forward to working with them again.",
      skills:
        "Website Design,AWS, Laravel, React.js, Payment Gateway Integration",
      name: "Kristian A",
      location: "Australia",
    },
    {
       content:
        "Centillion Softech delivers high-quality solutions on time with strong technical expertise and dependable support.",
      skills:
        "React, Angular, .Net Core, .net MVC",
      name: "Keyur Mavadiya",
      location: "India",
    }
  ];

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    cssEase: "cubic-bezier(0.87, 0, 0.13, 1)",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section>
      <div className="testimonial_area py-5 bg-light" style={{ background: 'var(--bg-light)' }}>
        <Container>
          <Row>
            <Col lg={12}>
              <div className="section_title text_center mb-5 mt-3" data-aos="fade-up">
                <div className="banner-badge mb-3">
                  <span>TESTIMONIALS</span>
                </div>
                <div className="section_main_title mb-3">
                  <h1 className="fw-bold display-5">What Our <span className="gradient-text">Clients Say</span></h1>
                </div>
                <p className="lead text-muted mx-auto" style={{ maxWidth: "700px" }}>
                  Credibly grow premier ideas rather than bricks-and-clicks strategic theme areas distributed for stand-alone web-readiness.
                </p>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <div className="testimonial-slider-wrapper py-4 px-2" data-aos="fade-up" data-aos-delay="100">
                <Slider {...settings}>
                  {testimonialLists.map((testimonial, index) => {
                    return (
                      <div className="px-3" key={index}>
                        <div className="modern-card p-4 h-100 d-flex flex-column" style={{ minHeight: '320px' }}>
                          <div className="mb-4">
                            <i className="fa-solid fa-quote-left fs-1" style={{ color: 'rgba(0, 128, 197, 0.2)' }}></i>
                          </div>
                          <p className="fs-5 text-dark fst-italic mb-3 flex-grow-1">
                            "{testimonial.content}"
                          </p>
                          <div className="mb-4">
                            <span className="badge bg-light text-primary border border-primary-subtle p-2">
                              {testimonial.skills}
                            </span>
                          </div>
                          <hr className="my-3 opacity-25" />
                          <div className="d-flex align-items-center gap-3 mt-auto">
                            <div className="rounded-circle d-flex align-items-center justify-content-center text-white fw-bold fs-5 shadow-sm" style={{ width: '50px', height: '50px', background: 'linear-gradient(135deg, var(--primary-color), var(--secondary-color))' }}>
                              {testimonial.name.charAt(0)}
                            </div>
                            <div>
                              <h5 className="mb-0 fw-bold text-dark">{testimonial.name}</h5>
                              <span className="text-muted small"><i className="fa-solid fa-location-dot me-1 text-primary"></i> {testimonial.location}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Slider>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
}

export default Testimonial;

